export default "__VITE_ASSET__BSbX1mjF__"